import { render, staticRenderFns } from "./bot-page.vue?vue&type=template&id=af603ad2&scoped=true&"
import script from "./bot-page.vue?vue&type=script&lang=js&"
export * from "./bot-page.vue?vue&type=script&lang=js&"
import style0 from "./bot-page.vue?vue&type=style&index=0&id=af603ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af603ad2",
  null
  
)

export default component.exports